import MainContext from './MainContext';
export default MainContext;
export const store = MainContext;
